// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","cardBorder":"Card_cardBorder__kGdT6","cardDescr":"Card_cardDescr__AYQQj","brandName":"Card_brandName__25WUn","iconsControl":"Card_iconsControl__V8Jkd"};